import { render, staticRenderFns } from "./informacionArgumentario.vue?vue&type=template&id=48d78949&scoped=true"
import script from "./informacionArgumentario.vue?vue&type=script&lang=js"
export * from "./informacionArgumentario.vue?vue&type=script&lang=js"
import style0 from "./informacionArgumentario.vue?vue&type=style&index=0&id=48d78949&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d78949",
  null
  
)

export default component.exports